var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100CirclePlusBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#474749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6908 10.0658C15.6908 9.68428 15.3815 9.375 15 9.375C14.6185 9.375 14.3092 9.68428 14.3092 10.0658V14.3092H10.0658C9.68428 14.3092 9.375 14.6185 9.375 15C9.375 15.3815 9.68428 15.6908 10.0658 15.6908H14.3092V19.9342C14.3092 20.3157 14.6185 20.625 15 20.625C15.3815 20.625 15.6908 20.3157 15.6908 19.9342V15.6908H19.9342C20.3157 15.6908 20.625 15.3815 20.625 15C20.625 14.6185 20.3157 14.3092 19.9342 14.3092H15.6908V10.0658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100CirclePlusBlack);
export default __webpack_public_path__ + "static/media/100-circle-plus-black.b1806fd5003b6b8cbbdf639b4a81bb48.svg";
export { ForwardRef as ReactComponent };